import { GridColDef } from "@mui/x-data-grid";
import { useTranslate } from "src/locales";
import { Box } from "@mui/material";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import ByzGrdEditButton from "src/components/core-components/mui/buttons-grid/ByzGrdEditButton";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";

// IDOGAN;446265;06032025
export interface ImageData {
  id: number;
  imageName: string;
  addedDate: string;
}

export const useImageColumns = ({
  onOpen,
  onDelete,
  onChange,
  extraAccess
}: {
  onOpen: (id: number) => void;
  onDelete: (id: number) => void;
  onChange: (id: number) => void;
  extraAccess: boolean;
}): GridColDef[] => {
  const { t } = useTranslate();

  return [
    {
      field: "open",
      headerName: t("buttons.open"),
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <ByzMuiButton
            variant2="outlined"
            color="primary"
            onClick={() => onOpen(params.row.id)}
          >
            {t("buttons.open")}
          </ByzMuiButton>
        </Box>
      ),
    },
    {
      field: "addedDate",
      headerName: t("basi-braden.added-date"),
      width: 150,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "imageName",
      headerName: t("basi-braden.image-name"),
      flex: 1,
      minWidth: 200,
    },
    {
      field: "change",
      headerName: t("buttons.edit"),
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <ByzGrdEditButton
            onClick={() => onChange(params.row.id)}
            disabled={!extraAccess}
          />
        </Box>
      ),
    },
    {
      field: "delete",
      headerName: t("buttons.delete", "capitalize"),
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <ByzGrdDeleteButton
            onClick={() => onDelete(params.row.id)}
            disabled={!extraAccess}
          />
        </Box>
      ),
    },
  ];
};
